<section class="content">
    <div class="content-block">
        <app-header-menu></app-header-menu>
        <div class="block-header">
            <app-breadcrumb [title]="'Dashboard'" [module]="'Master'" [subModule]="'General Master'"
                [moduleLink]="'/admin/dashboar-module'" [items1]="['Add Store Type']"
                [itemLink]="'/coremodule/Addstoretype'"></app-breadcrumb>
        </div>
        <div *ngIf="isLoading" class="loader-overlay">
            <mat-spinner diameter="40"></mat-spinner>
        </div>
        <div class="row clearfix main-contain-body">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="card">
                    <div class="body">
                        <div class="example-button-row mb-3">
                            <button mat-raised-button class="example-add-tab-button msr-2"
                                [routerLink]="['/coremodule', 'StoreLocation']" routerLinkActive="primary-color">
                                View Store Type
                            </button>
                            <button mat-raised-button class="example-add-tab-button msr-2"
                                [routerLink]="['/coremodule', 'Addstoretype']" routerLinkActive="primary-color">
                                Add Store Type

                            </button>
                            <button mat-raised-button class="example-add-tab-button msr-2"
                                [routerLink]="['/coremodule', 'Viewstore']" routerLinkActive="primary-color">
                                View Stores
                            </button>
                            <button mat-raised-button class="example-add-tab-button msr-2"
                                [routerLink]="['/coremodule', 'Addstorelocation']" routerLinkActive="primary-color">
                                Add Store

                            </button>

                        </div>

                        <div class="header">
                            <h1 class="my-class">Add Store Type</h1>
                        </div>

                        <form class="register-form m-4" [formGroup]="storeForm" (ngSubmit)="onSubmit()">

                            <div class="row">

                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-2">
                                    <table>
                                        <tbody>
                                            <td>HMHBBS</td>
                                        </tbody>
                                    </table>
                                </div>

                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-2">
                                    <mat-form-field class="example-full-width" appearance="outline">
                                        <mat-label>Store Type</mat-label>
                                        <input matInput formControlName="storeType" required>
                                    </mat-form-field>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-2">
                                    <mat-form-field class="example-full-width" appearance="outline">
                                        <mat-label>Description</mat-label>
                                        <input matInput formControlName="description" required>
                                    </mat-form-field>
                                </div>

                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-2">
                                    <mat-form-field class="example-full-width" appearance="outline">
                                        <mat-label>Alias Name</mat-label>
                                        <input matInput formControlName="aliasName" required>
                                    </mat-form-field>
                                </div>

                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-2">
                                    <mat-form-field class="example-full-width" appearance="outline">
                                        <mat-label>Remarks</mat-label>
                                        <input matInput formControlName="remarks" required>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-1"
                                    style="text-align: right; margin-top: 2%;">

                                    <button class="btn-space" mat-raised-button color="primary" type="submit">
                                        Submit
                                    </button>

                                    <button class="btn-space" mat-raised-button color="accent" type="button"
                                        (click)="onReset()">
                                        Reset
                                    </button>

                                    <button class="btn-space" mat-raised-button color="warn" type="button"
                                        (click)="onBack()">
                                        Back
                                    </button>
                                </div>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>